module.exports = __webpack_public_path__ + "static/media/char_parallax_2.743ad818.png";